import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ITenantConfiguration, tenantConfigurationsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';

const TENANT_CONFIGURATION_MODULE = 'tenantConfiguration';

const dataObjectModule = getDataObjectsModule<ITenantConfiguration>(tenantConfigurationsManager, 3);
const searchModule = getSearchModule<ITenantConfiguration>(tenantConfigurationsManager);

const tenantConfigurationModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions, getters });
store.registerModule(TENANT_CONFIGURATION_MODULE, tenantConfigurationModuleInstance);

export { TENANT_CONFIGURATION_MODULE };
